import { Col, Container, Row, Table } from 'react-bootstrap';
import Pill from '../components/Pill';
import SubPage from '../subpages/SubPage';

const Guide = () => {
  const pillInfo = {
    margin: '1rem 1rem 0rem 1rem',
    width: '8rem',
  };
  const title = '대회 안내';
  const parent_link = 'guide';
  const side_list = [
    ['outline', '대회 안내'],
    ['howto', '참가 신청 방법'],
    ['prize', '시 상'],
    ['gift', '기념품'],
    ['apply', '접수'],
    ['note', '유의사항'],
  ];
  const bg_info = {
    link: '/guide_banner.jpeg',
    text: title,
  };
  return (
    <div style={{ minHeight: '70rem' }}>
      <SubPage
        title={title}
        parent_link={parent_link}
        side_list={side_list}
        isOnePage={true}
        background_info={bg_info}
      />
      <Container fluid className="col-lg-8 offset-lg-3">
        <Container>
          <h1 id="outline" className="pt-5 mb-5">
            대회 안내
          </h1>
          <Pill
            title="대회명"
            content="제24회 대청호마라톤대회"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="일시"
            content="2025.10.19.(일) 08시 30분 집결"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="대회 장소"
            content="대청공원"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="운영 종목"
            content="건강코스(5km), 미니코스(10km), 하프코스(21.0975km)"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="참가인원(결제완료순)"
            content="건강코스 - 1,000명 / 미니코스 - 1,500명 / 하프코스 - 1,000명"
            margin={pillInfo.margin}
            titleWidth={'14rem'}
          />
          <Pill
            title="주최"
            content="대덕구・대전광역시체육회・한국수자원공사・디트뉴스24"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="주관"
            content="대전광역시 대덕구체육회, 대전광역시육상연맹"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />

          <Pill
            title="후원"
            content="대전광역시"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
        </Container>
        <Container>
          <h1 id="howto" className="mt-5 pt-5 mb-5">
            참가 신청 방법
          </h1>
          <Pill
            title="홈페이지"
            content="http://dcmarathon.or.kr"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          {/* <h3>신청 방법</h3>
        <p>각 종목별 선착순(종목에 따라 지역 제한 여부)</p> */}
          <Pill
            title="TEL"
            content="042-933-8890, 042-934-8890"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="FAX"
            content="042-934-8878"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <div
            className="border rounded p-lg-5 p-3 mb-5 fs-sm-small text-primary text-center"
            style={{ lineHeight: '1.8rem' }}
          >
            <p>
              참가비는 참가신청 접수 후, 신용카드 결제 및 참가비 계좌로 입금하여 주시기 바랍니다.
            </p>
            <p>배포물의 확실한 물품 우송을 위해 주소 및 연락처를 정확하게 기재해 주셔야 합니다.</p>
            <p>2인 이상 단체참가는 인터넷 상의 [단체참가신청]을 통해 신청해야 합니다.</p>
          </div>
          <div style={{ overflowX: 'scroll', padding: '0' }} className="pb-0 mb-0">
            <Pill
              title="참가종목/자격/제한시간"
              content=""
              margin={pillInfo.margin}
              titleWidth={'15rem'}
            />
            <Table
              style={{ minWidth: '600px' }}
              className="fs-sm-small text-center table-bordered mb-0"
            >
              <thead>
                <tr>
                  <td>
                    종<span style={{ display: 'inline-block', width: '1.8rem' }}></span>목
                  </td>
                  <td className="text-center">참가비</td>
                  <td>참가자격</td>
                  <td>제한시간</td>
                  <td>출발시간</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    하프코스
                    <br />
                    (21.0975km)
                  </td>
                  <td style={{ lineHeight: '3rem' }}>35,000원</td>
                  <td style={{ lineHeight: '3rem' }}>만 18세 이상 신체 건강한 남,여</td>
                  <td style={{ lineHeight: '3rem' }}>2시간30분</td>
                  <td style={{ lineHeight: '3rem' }}>10.19.(일) 09:00</td>
                </tr>
                <tr>
                  <td>
                    미니코스
                    <br />
                    (10km)
                  </td>
                  <td style={{ lineHeight: '3rem' }}>35,000원</td>
                  <td style={{ lineHeight: '3rem' }}>초등학생 이상 남,여</td>
                  <td style={{ lineHeight: '3rem' }}>1시간30분</td>
                  <td style={{ lineHeight: '3rem' }}>10.19.(일) 09:15</td>
                </tr>
                <tr>
                  <td>
                    건강코스
                    <br />
                    (5km)
                  </td>
                  <td style={{ lineHeight: '3rem' }}>20,000원</td>
                  <td style={{ lineHeight: '3rem' }}>제한없음</td>
                  <td style={{ lineHeight: '3rem' }}>1시간</td>
                  <td style={{ lineHeight: '3rem' }}>10.19.(일) 09:30</td>
                </tr>
              </tbody>
            </Table>
            <br />
            <p>
              {' '}
              * 초·중·고등학교 10인 이상 참가 단체 : 건강코스 15,000원, 미니코스 30,000 원(학교 단체
              참가시 학생에 한하여 할인 적용)
            </p>
            <p> * 장애인임을 확인할 수 있는 서류 제출시 하프코스, 미니코스에 한하여 2만원</p>
            <p> - 제출방법 : 이메일 : ddsc8890@naver.com / 팩스 : 042-934-8878</p>
          </div>
          <Pill
            title="경기 규칙"
            content="2025년도 대한육상연맹의 경기규칙에 준하여 실시하되 상황에 따라 일부 변경될 수 있음"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
        </Container>
        <Container id="prize">
          <h1 className="pt-5 mt-5 mb-5">시상</h1>
          <div className="mb-5">
            <Pill title="시상식" content=" " margin="0" titleWidth="8rem" />
            <div style={{ overflowX: 'scroll' }}>
              <Table
                style={{ minWidth: '600px' }}
                className="fs-sm-small text-center table-bordered"
              >
                <tbody>
                  <tr>
                    <td>건강코스(5km) 종합입상자 시상식</td>
                    <td>대회당일 11시 00분</td>
                  </tr>
                  <tr>
                    <td>미니코스(10km) 종합입상자 시상식</td>
                    <td>대회당일 11시 10분</td>
                  </tr>
                  <tr>
                    <td>하프코스(21.0975km) 종합입상자 시상식</td>
                    <td>대회당일 11시 20분</td>
                  </tr>
                  <tr>
                    <td>단체참가상</td>
                    <td>
                      대회전 입금(
                      <span className="text-primary">할인대상자 제외</span>)
                    </td>
                  </tr>
                </tbody>
              </Table>
              <Pill title="종합 시상(남/여)" content=" " margin="0" titleWidth="12rem" />
              <Table
                style={{ minWidth: '600px' }}
                className="fs-sm-small text-center table-bordered"
              >
                <thead>
                  <tr>
                    <th style={{ width: '13%', lineHeight: '3.5rem' }} rowSpan={2}>
                      순위
                    </th>
                    <th colSpan={2}>건강코스(5km)</th>
                    <th colSpan={2}>미니코스(10km)</th>
                    <th colSpan={2}>하프코스(21.0975km)</th>
                  </tr>
                  <tr>
                    <th>남</th>
                    <th>여</th>
                    <th>남</th>
                    <th>여</th>
                    <th>남</th>
                    <th>여</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1위</td>
                    <td>100,000원+상장</td>
                    <td>100,000원+상장</td>
                    <td>200,000원+상장</td>
                    <td>200,000원+상장</td>
                    <td>500,000원+상장</td>
                    <td>500,000원+상장</td>
                  </tr>
                  <tr>
                    <td>2위</td>
                    <td>70,000원+상장</td>
                    <td>70,000원+상장</td>
                    <td>150,000원+상장</td>
                    <td>150,000원+상장</td>
                    <td>300,000원+상장</td>
                    <td>300,000원+상장</td>
                  </tr>
                  <tr>
                    <td>3위</td>
                    <td>50,000원+상장</td>
                    <td>50,000원+상장</td>
                    <td>100,000원+상장</td>
                    <td>100,000원+상장</td>
                    <td>200,000원+상장</td>
                    <td>200,000원+상장</td>
                  </tr>
                  <tr>
                    <td>4위</td>
                    <td>50,000원+상장</td>
                    <td>50,000원+상장</td>
                    <td>70,000원+상장</td>
                    <td>70,000원+상장</td>
                    <td>150,000원+상장</td>
                    <td>150,000원+상장</td>
                  </tr>
                  <tr>
                    <td>5위</td>
                    <td>50,000원+상장</td>
                    <td>50,000원+상장</td>
                    <td>70,000원+상장</td>
                    <td>70,000원+상장</td>
                    <td>150,000원+상장</td>
                    <td>150,000원+상장</td>
                  </tr>
                </tbody>
              </Table>
              <p>하프코스, 미니코스 완주자 전원은 기록증 및 완주메달 수여</p>
              <p>
                시상금은 해당금액의 <span className="text-custom-red">상품권</span>으로 지급
              </p>
              <Pill title="연대별시상(남/여 1~3위)" content=" " margin="0" titleWidth="15rem" />

              <Table
                style={{ minWidth: '600px' }}
                className="fs-sm-small text-center table-bordered"
              >
                <thead>
                  <tr>
                    <th>종목</th>
                    <th>30대 미만</th>
                    <th>30대</th>
                    <th>40대</th>
                    <th>50대</th>
                    <th>60대 이상</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      하프코스 <br /> (21.0975km)
                    </td>
                    <td>상장+부상(5만원 상당)</td>
                    <td>상장+부상(5만원 상당)</td>
                    <td>상장+부상(5만원 상당)</td>
                    <td>상장+부상(5만원 상당)</td>
                    <td>상장+부상(5만원 상당)</td>
                  </tr>
                  <tr>
                    <td>
                      미니코스 <br /> (10km)
                    </td>
                    <td>상장+부상(3만원 상당)</td>
                    <td>상장+부상(3만원 상당)</td>
                    <td>상장+부상(3만원 상당)</td>
                    <td>상장+부상(3만원 상당)</td>
                    <td>상장+부상(3만원 상당)</td>
                  </tr>
                </tbody>
              </Table>
              <p>종합시상 수상자 및 제한 시간 이후 완주자는 연대별 시상에서 제외.</p>
              <p>대회일 현재 주민등록번호의 만나이를 기준으로함.</p>
              <p>전자칩에 의한 기록(넷타임)에 의하여 대회 홈페이지 발표 후 개별 우송</p>
              <Pill title="단체 참가상" content=" " margin="0" titleWidth="15rem" />
              <p>
                10명 이상 신청시 교통비 지급{' '}
                <span className="text-custom-red">(단, 건강코스 또는 학생 단체 참가자 제외)</span>
              </p>
              <p>종목에 관계없이 30명이상 단체 참가시 부스 및 현수막 제공(요청시)</p>
              <Table
                style={{ minWidth: '600px' }}
                className="fs-sm-small text-center table-bordered"
              >
                <thead>
                  <tr>
                    <th>참가신청인원</th>
                    <th>시상금</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>10명 이상</td>
                    <td>30,000원</td>
                  </tr>
                  <tr>
                    <td>20명 이상</td>
                    <td>80,000원</td>
                  </tr>
                  <tr>
                    <td>30명 이상</td>
                    <td>150,000원</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </Container>
        <Container>
          <h1 id="gift" className="pt-5 mt-5 mb-5">
            기념품
          </h1>
          <p>1. 안내책자</p>
          <p>2. 완주메달(완주자에 한함)</p>
          <p>3. 기록증(하프코스, 미니코스 완주자에 한함)</p>
          <p>4. 기능성 티셔츠</p>
          <h3 id="gift" className="text-center mt-4 mb-4">
            기능성 티셔츠 사이즈
          </h3>
          <Table style={{ minWidth: '600px' }} className="fs-sm-small text-center table-bordered">
            <thead>
              <tr>
                <th>구분</th>
                <th>110(3XL)</th>
                <th>105(2XL)</th>
                <th>100(XL)</th>
                <th>95(L)</th>
                <th>90(M)</th>
                <th>85(S)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>총기장</td>
                <td>73</td>
                <td>70.5</td>
                <td>68</td>
                <td>65.5</td>
                <td>63</td>
                <td>60.5</td>
              </tr>
              <tr>
                <td>가슴둘레</td>
                <td>114</td>
                <td>109</td>
                <td>104</td>
                <td>99</td>
                <td>94</td>
                <td>89</td>
              </tr>
              <tr>
                <td>밑단둘레</td>
                <td>112</td>
                <td>107</td>
                <td>102</td>
                <td>97</td>
                <td>92</td>
                <td>87</td>
              </tr>
              <tr>
                <td>소매밑단</td>
                <td>18.25</td>
                <td>17.75</td>
                <td>17</td>
                <td>16.25</td>
                <td>15.75</td>
                <td>15</td>
              </tr>
            </tbody>
          </Table>
          {/* <h3 id="gift" className="text-center mt-4 mb-4">
            러닝조끼 사이즈(하프코스)
          </h3>
          <Table style={{ minWidth: '600px' }} className="fs-sm-small text-center table-bordered">
            <thead>
              <tr>
                <th>구분</th>
                <th>110(3XL)</th>
                <th>105(2XL)</th>
                <th>100(XL)</th>
                <th>95(L)</th>
                <th>90(M)</th>
                <th>85(S)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>총기장</td>
                <td>67</td>
                <td>65</td>
                <td>62.5</td>
                <td>60</td>
                <td>57</td>
                <td>55</td>
              </tr>
              <tr>
                <td>가슴둘레(단면)</td>
                <td>54</td>
                <td>52</td>
                <td>50</td>
                <td>48</td>
                <td>45</td>
                <td>43</td>
              </tr>
            </tbody>
          </Table> */}
        </Container>
        <Container id="apply">
          <h1 className="pt-5 mt-5 mb-5 ">접수</h1>
          <Pill
            title="접수기간"
            content="2025.04.28.(월) 10:00 ~ 2025.07.11.(금) 16:00"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <p className="under-pill-text text-primary">
            *접수기간 이후에는 신청 취소 및 환불이 불가합니다.
          </p>
          <Pill title="참가비 입금계좌" content="" margin={pillInfo.margin} titleWidth="10rem" />

          <div style={{ overflowX: 'scroll' }}>
            <Table style={{ minWidth: '600px' }} className="fs-sm-small text-center table-bordered">
              <thead>
                <tr>
                  <th>은행</th>
                  <th>입금계좌</th>
                  <th>예금주</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>하나은행</td>
                  <td>654-910058-91905</td>
                  <td>대전광역시 대덕구체육회</td>
                </tr>
              </tbody>
            </Table>
          </div>
          <p className="text-custom-red">
            무통장 입금시, 입금자란에 성명과 휴대폰번호 뒷자리(4자) 함께 기재해 주십시오. 예시)
            홍길동0001
          </p>
        </Container>
        <Container id="note">
          <h1 className="pt-5 mt-5 mb-5">유의사항</h1>
          <Pill title="기록시스템 안내" content="" margin={pillInfo.margin} titleWidth="10rem" />
          <p className="under-pill-text">
            대회본부에서는 기록의 정확성을 기하기 위해{' '}
            <span className="text-primary">칩(chip)을 사용한 무선인식 시스템</span>을 적용하고
            있으며, 반환점 및 골인지점을 통과하는 즉시 참가자의 기록이 표출됩니다.
          </p>

          <img src="/chip-simple.png" alt="chip" style={{ width: '100%' }} />
          <div
            className="border rounded p-lg-5 p-3 mb-5 fs-sm-small"
            style={{ lineHeight: '1.8rem' }}
          >
            <p className="text-primary text-center">전자칩 유의사항</p>
            <p>1. 배번호에 동봉되어 있는 일회용 칩을 접거나 구기시면 안됩니다.</p>
            <p>
              2. 만약 칩을 접거나 구길 경우, 출발, 골인선 및 반환점 등에 설치된 기록측정용 매트를
              밟지 않은 경우 기록이 측정되지 않아 실격처리 됩니다.
            </p>
            <p>3. 칩은 반드시 운동화 끈에 달아주세요. (*손목에 착용시 기록계측이 안됩니다.)</p>
            <p>4. 칩은 일회용 칩으로 반납하실 필요가 없습니다.</p>
            <p>
              5. 배번호에 칩이 동봉되어 있는지를 꼭 확인해 주시고, 칩이 없을 경우 사무국으로 바로
              연락주셔서 조치를 받아주십시오.
            </p>
            <p>6. 종합시상은 건타임으로 시상하며, 기록은 넷 타임으로 제공됩니다.</p>
          </div>
          <Pill title="건강상태 확인" content="" margin={pillInfo.margin} titleWidth="10rem" />
          <div
            className="border rounded p-lg-5 p-3 mb-5 fs-sm-small"
            style={{ lineHeight: '1.8rem' }}
          >
            <p>
              1. 대회 전 참가자는 반드시 마라톤을 완주 할 수 있는지 스스로 건강상태를 확인하여
              이상이 없는 경우에만 참가해야 합니다.
            </p>
            <p>2. 심장 및 뇌혈관계 질환을 앓고 있거나 치료중인 자는 참가할 수 없습니다.</p>
            <p>
              3. 접수 후 또는 경기 전에 심장 및 뇌혈관계 질환에 노출되어 치료를 필요로 할 경우
              질환의 경중을 막론하고 대회에 참가하시면 안됩니다.
            </p>
            <p>
              4. 과거에 이러한 병력이 있는 참가자는 완치되었다고 하더라도 대회 사무국 에 사전
              통보하여야 합니다.
            </p>
            <p>
              5. 참가자를 위해 “주최자배상책임보험”에 가입되어 있으며, 보상규정 한도 외에는 책임을
              지지 않으므로 참가자는 개인별 보험에 가입하시기를 권장 드리며 대책을 강구하시고
              참가하시기 바랍니다.
            </p>
          </div>
          <Pill
            title="물품 보관"
            content="대회 당일 탈의실 및 물품보관소를 운영합니다."
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <p className="under-pill-text text-primary">
            (단, 귀중품은 각자 보관해 주시고 분실시 책임지지 않습니다.)
          </p>
          <Pill
            title="교통통제 및 경기시간 제한"
            content=""
            margin={pillInfo.margin}
            titleWidth="14rem"
          />
          <p className="under-pill-text">
            1. 대회진행용 차량을 제외한 일체의 차량 및 자전거, 전동킥보드, 오토바이의 운행을
            금합니다.
          </p>
          <p className="under-pill-text">
            2. 대회진행용 차량은 대회본부가 발급하는 스티커를 앞쪽 오른편 상단에 부착해야 합니다.
          </p>
          <p className="under-pill-text">
            3. 하프코스의 경우 출발 후 2시간30분, 미니코스는 1시간30분, 건강코스는 1시간 내에
            결승점에 도착해야 합니다. 만약 참가자가 주최측 회수차량에 탑승을 거부하고 계속
            레이스하다 발생하는 사고에 대한 책임은 본인에게 있으며, 주최측은 책임을 지지 않을 것임을
            알려드리오니 양지하시기 바랍니다.
          </p>
          <Pill
            title="회수차 및 의무차, 의료"
            content=""
            margin={pillInfo.margin}
            titleWidth="14rem"
          />
          <p className="under-pill-text">
            1. 코스 주로에는 낙오자, 환자를 위한 회수차와 의무차가 운행됩니다.
          </p>
          <p className="under-pill-text">
            2. 다음의 경우에는 회수차 또는 의무차에 승차해 주시기 바랍니다.
          </p>
          <p className="under-pill-text">
            3. 관문시간 통제 이후 선수는 레이스를 중지하고 임원의 지시에 따라 회수차에 승차해
            주십시오.
          </p>
          <p className="under-pill-text">
            4. 레이스 도중 주행이 곤란하거나 이상이 발생했을 때에는 부근의 심판요원 또는
            운영요원에게 연락하여 지시를 받으십시오.
          </p>
          <p className="under-pill-text">
            5. 공식 의무원 또는 심판장으로부터 레이스 중지를 명령받았을 때에는 그 지시에 따라야
            합니다.
          </p>
          <p className="under-pill-text">
            6. 자신의 건강을 위해 무리한 레이스를 자제하여 주시기 바랍니다.
          </p>
          <p className="under-pill-text">
            7. 의무요원을 태운 구급차가 코스 주로에 대기하며 결승점에 휴식 및 응급조치 및
            스포츠마사지용 부스를 운영합니다.
          </p>
          <p className="under-pill-text">
            8. 경기 중 발생한 부상 또는 사고 등에 대하여 보험 한도 내에서 책입집니다. (대회본부에
            의무센터를 설치 운영합니다.)
          </p>
          <Pill title="기타 사항" content="" margin={pillInfo.margin} titleWidth={pillInfo.width} />
          <p className="under-pill-text">
            1. 주로에서의 안전은 주자 본인의 책임이므로 각자의 안전에 최우선을 두어야 합니다.
          </p>
          <p className="under-pill-text">
            2. 주자는 주최측에 주최측의 과실이 아닌 개인 부주의로 인한 사고와 관련하여 어떠한 책임도
            물을 수 없습니다.
          </p>
          <p className="under-pill-text">
            3. 부상 및 사정에 의하여 경기를 진행할 수 없을 시에는 즉시 대회본부에 알려야 합니다.
          </p>
          <p className="under-pill-text">
            4. 천재 지변이나 자연재해 발생 시 대회가 중지되며 참가비는 환불되지 않습니다.
          </p>
          <p className="under-pill-text">
            5. 대회 참가신청기간 이후에는 참가비는 환불되지 않습니다.
          </p>
          <p className="under-pill-text">
            6. 본 대회에서 촬영된 초상권은 대회 조직위에 귀속됩니다.
          </p>
          <p className="under-pill-text">
            7. 참가 신청자의 보다 나은 서비스 제공을 위해 개인 정보를 보험사, 대회 협력사와 공유할
            수 있습니다. 그 외 다른 영리적인 목적으로 개인정보를 타인 또는 타 기업, 기관에 공개하지
            않습니다.
          </p>
        </Container>
      </Container>
    </div>
  );
};
export default Guide;
